import React from "react"
import { Link } from "gatsby"
import CookieConsent from "../components/CookieConsent";
import logo from "../images/footer-logo.png"
import fbIcon from "../images/radnet_facebook.svg"
import twIcon from "../images/radnet_twitter.svg"
import instaIcon from "../images/radnet_instagram.svg"
import ytIcon from "../images/radnet_youtube.svg"
import pinIcon from "../images/radnet_pinterest.svg"
import ttIcon from "../images/radnet_tiktok.svg"
import liIcon from "../images/radnet_linkedin.svg"

export default () => {
    return (
        <footer className="cf">
            {/* Main footer content area with columns */}
            <div className="container-outer-xs container-outer-m container-outer">
                <div className="fl-l w-100">
                    {/* Left column - logo and social */}
                    <div className="fl-l w-25-l tl footer-social">
                        <Link to="/"><img className="logo" src={logo} alt="RadNet Prostate" /></Link>
                        <ul className="pt3 pt2-l">
                            <li><a href="https://www.instagram.com/radnetimaging" target="_blank" rel="noreferrer"> <img src={instaIcon} width="40" alt="RadNet Instagram" /> </a> </li>
                            <li><a href="https://www.facebook.com/radnetimaging" target="_blank" rel="noreferrer"> <img src={fbIcon} width="40" alt="RadNet Facebook" /> </a> </li>
                            <li><a href="https://www.twitter.com/radnetimaging" target="_blank" rel="noreferrer"> <img src={twIcon} width="40" alt="RadNet Twitter" /> </a> </li>
                            <li><a href="https://www.youtube.com/radnetvideos" target="_blank" rel="noreferrer"> <img src={ytIcon} width="40" alt="RadNet Youtube Videos" /> </a> </li>
                            <li><a href="https://www.pinterest.com/RadNetImaging" target="_blank" rel="noreferrer"> <img src={pinIcon} width="40" alt="RadNet Pinterest" /> </a> </li>
                            <li><a href="https://www.tiktok.com/@radnetimaging" target="_blank" rel="noreferrer"> <img src={ttIcon} width="40" alt="RadNet TikTok" /> </a> </li>
                            <li><a href="https://www.linkedin.com/company/radnet" target="_blank" rel="noreferrer"> <img src={liIcon} width="40" alt="RadNet LinkedIn" /> </a> </li>
                        </ul>
                        <p className="tl pr4-l" style={{ maxWidth: "400px" }}>RadNet has been a national leader in providing high quality, cost-effective diagnostic imaging services for over 40 years. We are dedicated to advancing early detection of disease and to empowering patients to take charge of their health.</p>
                    </div>
                    
                    {/* About column */}
                    <div className="fl-l w-25-l tl pl4-l">
                        <h5 className="tl">About</h5>
                        <ul className="tl">
                            <li><Link to="/program/">RadNet Prostate Program</Link></li>
                            <li><Link to="/program/prostate-101/">Prostate 101</Link></li>
                            <li><Link to="/blog/">Blog & News</Link></li>
                        </ul>
                    </div>

                    {/* Services column */}
                    <div className="fl-l w-25-l tl pl4-l">
                        <h5 className="tl">Services</h5>
                        <ul className="tl">
                            <li><Link to="/prostate-mri/">Prostate MRI</Link></li>
                            <li><Link to="/enhanced-prostate-screening/">Enhanced Prostate Screening</Link></li>
                            <li><Link to="/tulsa/">TULSA Procedure</Link></li>
                            <li><Link to="/pet-ct/">PET/CT</Link></li>
                        </ul>
                    </div>
                    
                    {/* Contact & Information column */}
                    <div className="fl-l w-25-l tl pl4-l">
                        <h5 className="tl">Contact & Information</h5>
                        <ul className="tl">
                            <li><a href="https://www.radnet.com/privacy-statement/" rel="noreferrer" target="_blank">Policies & Compliance</a></li>
                            <li><a href="http://radnet.com/disclaimer/" rel="noreferrer" target="_blank">Disclaimer</a></li>
                            <li><a href="http://radnet.com/hipaa-notification-ca/" rel="noreferrer" target="_blank">HIPAA Notification</a></li>
                            <li><a href="http://radnet.com/anti-discrimination-policy" rel="noreferrer" target="_blank">Anti-Discrimination Policy</a></li>
                            <li><a href="https://www.radnet.com/accessibility-statement" rel="noreferrer" target="_blank">Accessibility Statement</a></li>
                            <li><a href="https://www.radnet.com/consumer-rights-ca" rel="noreferrer" target="_blank">Your Privacy Choices</a></li>
                            <li><a href="javascript:void(0);" data-cc="c-settings" className="cc-link" aria-haspopup="dialog">Privacy Settings</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <CookieConsent/>
        </footer>
    )
}
